const LOGIN = "/login/callback";
const SIGNUP_INITIATE = "/signup";
const SIGNIN = "/signin";

const SIGNUP_PHASE_1 = "/emailverification";
const SIGNUP_PHASE_2 = "/congratulations";
const SIGNUP_PHASE_3 = "/emailalreadyverify";
const SIGNUP_PHASE_4 = "/linkexpired";
const SIGNUP_PHASE_5 = "/setpassword/:token";
const SIGNUP_PHASE_6 = "/accountsetup";
const SIGNUP_PHASE_7 = "/complete-setup/";
const SIGNUP_PHASE_8 = "/complete-google-setup";
const CHOOSE_LOGIN_FLOW = "/choose-login-flow";
const ACCEPT_INVITATION = "/accept-invitation/";
const REDIRECT_TO_TENANT = "/redirect-to-tenant";

const SUCCESS = "/success";

const PORTAL_ALLOWED_ROUTES = [
  SIGNUP_INITIATE,
  SIGNIN,
  SIGNUP_PHASE_7,
  SIGNUP_PHASE_8,
  ACCEPT_INVITATION,
  REDIRECT_TO_TENANT,
  CHOOSE_LOGIN_FLOW,
];

const BYPASS_DOMAIN_CHECK_ROUTES = [ACCEPT_INVITATION];

const RESERVED_DOMAINS = ["portal", "app", "assets", "login"];
const REDIRECT_TO_PORTAL = ["assets"];

const DASHBOARD = "/dashboard";
const ONBOARDING = "/onboarding";
const ATTENDANCE = "/attendance";
const LIVESTREAM = "/livestream";
const WELLNESS = "/wellness360";
const ACTIVITY = "/activity";
const PRODUCTIVITY = "/productivity";
const TIMELINE = "/timeline";
const APPLICATION = "/application";
const SETTINGS = "/settings";
const SETTINGS_ORGANIZATION_BILLING = "/settings/organization";
const SETTINGS_USER_MANAGEMENT = "/settings/user-management";
const SETTINGS_PRODUCTIVITY = "/settings/productivity";
const SETTINGS_INTEGRATIONS = "/settings/integrations";
const SETTINGS_ATTENDANCE = "/settings/attendance";
const SETTINGS_COMPLIANCE_SECURITY = "/settings/compliance-security";
const SETTINGS_EMAILS_ALERTS = "/settings/emails-alerts";
const SETTINGS_MAINTENANCE = "/settings/maintenance";
const SETTINGS_UI = "/settings/ui";

const FIELD = "/field";
const ALERTS = "/alerts";
const REPORTS = "/reports";
const ME = "/user-detail";
const PROJECTS = "/projects";
const TASK = "/tasks";
const DOWNLOAD = "/download";
const NOTEBOOK = "/notebook";
const LEAVE_MANAGEMENT = "/leaves";
const EXTENSION_LOGIN = "/extension-login";
const CLEAR_COOKIES = "/clear-cookies";
const GOALS = "/goals";
const SCREENSHOT = "/screenshot";
const DEVICE360 = "/devices";
const MANUALTIME = "/manualtime";
const TIMESHEET = "/timesheet";
const USB_DETECTION = "/usbdetection";
const INTEGRATION_DASHBOARD = "/integrations-dashboard";

// error
const FORBIDDEN = "/403";
const NOT_FOUND = "/404";
const BILLING_ALLOWED_ROUTES = [
  SETTINGS,
  DOWNLOAD,
  SUCCESS,
  SETTINGS_ORGANIZATION_BILLING,
  SETTINGS_USER_MANAGEMENT,
  SETTINGS_PRODUCTIVITY,
  SETTINGS_INTEGRATIONS,
  SETTINGS_ATTENDANCE,
  SETTINGS_COMPLIANCE_SECURITY,
  SETTINGS_EMAILS_ALERTS,
  SETTINGS_MAINTENANCE,
];

export const accessControls = {
  [DASHBOARD]: "dashboard",
  [ATTENDANCE]: "attendance",
  [LIVESTREAM]: "live_stream",
  [FIELD]: "field",
  [TIMELINE]: "timeline",
  [SCREENSHOT]: "screenshots",
  [ACTIVITY]: "activity",
  [PRODUCTIVITY]: "productivity",
  [GOALS]: "goals",
  [APPLICATION]: "apps_and_urls",
  [WELLNESS]: "wellness",
  [DEVICE360]: "devices",
  [USB_DETECTION]: "usbdetection",
  [MANUALTIME]: "manual_time",
  [ALERTS]: "alerts",
  [PROJECTS]: "projects",
  [LEAVE_MANAGEMENT]: "leaves",
  [NOTEBOOK]: "notebook",
  [ME]: "user_detail",
  [REPORTS]: "reporting",
  [USB_DETECTION]: "usb_detection",
  [TIMESHEET]: "timesheet",
  [INTEGRATION_DASHBOARD]: "integrations-dashboard",
};

export const reportingKeys = [
  "break",
  "daily_attendance",
  "monthly_attendance",
  "monthly_in_out",
  "activity",
  "application",
  "productivity",
  "group_insight",
  "project",
  "logs",
  "manual_time",
  "integration",
  "alert",
  "dynamic",
  "device",
  "timesheet",
  "usb_detection",
];

export {
  LOGIN,
  SIGNUP_INITIATE,
  SIGNIN,
  CHOOSE_LOGIN_FLOW,
  SIGNUP_PHASE_1,
  SIGNUP_PHASE_2,
  SIGNUP_PHASE_3,
  SIGNUP_PHASE_4,
  SIGNUP_PHASE_5,
  SIGNUP_PHASE_6,
  SIGNUP_PHASE_7,
  SIGNUP_PHASE_8,
  DASHBOARD,
  ONBOARDING,
  ATTENDANCE,
  LIVESTREAM,
  ACTIVITY,
  WELLNESS,
  PRODUCTIVITY,
  TIMELINE,
  APPLICATION,
  SETTINGS,
  FIELD,
  ALERTS,
  REPORTS,
  RESERVED_DOMAINS,
  REDIRECT_TO_PORTAL,
  FORBIDDEN,
  NOT_FOUND,
  PORTAL_ALLOWED_ROUTES,
  BYPASS_DOMAIN_CHECK_ROUTES,
  // COOKIE_PATHS,
  ME,
  PROJECTS,
  TASK,
  BILLING_ALLOWED_ROUTES,
  SCREENSHOT,
  DOWNLOAD,
  NOTEBOOK,
  ACCEPT_INVITATION,
  LEAVE_MANAGEMENT,
  DEVICE360,
  USB_DETECTION,
  MANUALTIME,
  CLEAR_COOKIES,
  GOALS,
  SUCCESS,
  REDIRECT_TO_TENANT,
  EXTENSION_LOGIN,
  TIMESHEET,
  INTEGRATION_DASHBOARD,
  SETTINGS_ORGANIZATION_BILLING,
  SETTINGS_USER_MANAGEMENT,
  SETTINGS_PRODUCTIVITY,
  SETTINGS_INTEGRATIONS,
  SETTINGS_ATTENDANCE,
  SETTINGS_COMPLIANCE_SECURITY,
  SETTINGS_EMAILS_ALERTS,
  SETTINGS_MAINTENANCE,
  SETTINGS_UI,
};
